// extracted by mini-css-extract-plugin
export var content = "_vg-1";
export var wrapper = "_vg-0";